import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { MultiselectModule } from "libraries/module/formbuilder/fields/multiselect/multiselect.module";
import { DictionarySearchResourceModule } from "libraries/service/resources/dictionary-search/dictionary-search-resource.module";
import { AirportSelectComponent } from "./airport-select.component";
import { LocalizedModule } from "libraries/pipes/localized/localized.module";
import { AutocompleteModule } from 'libraries/module/formbuilder/fields/autocomplete/autocomplete.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


@NgModule({
    imports: [
        CommonModule,
        MultiselectModule,
        DictionarySearchResourceModule,
        LocalizedModule,
        AutocompleteModule,
        FontAwesomeModule,
    ],
    exports: [AirportSelectComponent],
    declarations: [AirportSelectComponent],
    providers: [],
})
export class AirportSelectModule {
}
